/**
 * @file SLA Page
 * @author zhenglujie(zhenglujie@baidu.com))
 * Copyright (c) 2019-06-29 Baidu
 */

import React from 'react';
import {connect} from 'react-redux';

import './index.less';

class SLA extends React.Component {
    render() {
        const businessFunc = '百度短网址提供专业的网址缩短、还原服务。具有稳定、快速、安全的特点，支'
                            + '持批量缩短、批量短网址还原、数据报表、开放API接口等服务。';
        const businessAvail = '百度短网址服务为用户提供免费的使用额度，其中为付费用户服务承诺业务可'
                            + '用性不低于99.9%，使用免费额度的未付费用户不承诺SLA。';
        const serviceAvailCalcuFormula = '服务可用性计算公式：实际可用性 =（总时间 - 实际不可用时间）'
                                        + '/ 总时间 x 100%';
        const businessAvailDesc1 = '1. 以一个自然月作为一个服务周期，不满一个月不计算为一个服务周期，'
                                + '也不计算业务可用性。';
        const businessAvailDesc2 = '2. 不可用时间：百度短网址所提供的服务在连续的10分钟或更长时间不可'
                                + '使用方计为不可用时间。不可用时间不包括日常系统维护时间、由用户'
                                + '原因、第三方原因或不可抗力导致的不可用时间。连续的一段时间或更'
                                + '长时间不可使用方计为不可用时间，低于该时间段不计入不可用时间。';
        const businessAvailDesc3 = '3. 不可用定义：由于百度智能云服务器的设备问题、机房问题、产品功能'
                                + '问题或操作不当导致短网址服务中断，则判断为服务不可用。';
        const faultRecovCapa = '百度智能云为付费用户的云服务提供7×24小时的运行维护，并以在线工单和'
                            + '电话报障等方式提供技术支持，具备完善的故障监控、自动告警、快速定位、'
                            + '快速恢复等一系列故障应急响应机制。';
        const businessResourceAllocationCapa = '百度短网址服务不设置流量限制，客户可根据实际业务需要动态扩展'
                            + '，但是大规模的流量增加（短网址注册：请求量超过 5000次QPS、 短网址跳转：请求'
                            + '量超过1万次QPS），客户需至少提前7个工作日书面告知百度智能云，以免'
                            + '影响可用性。未提前告知的大流量增加引起的服务问题不包括在不可用时间内。'
                            + '百度短网址服务的免费用户百度智能云不承诺其可用性，在资源紧张情况下，'
                            + '会优先保障付费用户的服务资源。';
        const serviceAuditability = '百度智能云在依据现有法律法规体系下，出于配合政府监管部门的监管或安全'
                            + '取证调查等原因的需要，在符合流程和手续完备的情况下，可以提供相关信'
                            + '息，包括百度短网址服务关键组件的运行日志、运维人员的操作记录、客户操'
                            + '作记录等信息。';
        const serviceMeasureAccuracy = '百度智能云百度短网址服务的费用按照点数计算。'
                            + '具体计费标准以百度短网址官网公布的计费模式和价格为准。';
        const scopeOfUse = '系统日常维护时间;网络攻击；由于用户未按照百度智能云在官方页面上'
                        + '展示的相关服务说明、技术规范、使用流程等使用百度短网址产品导致'
                        + '的不可用时间；由用户自身其他方面原因或第三方的软件、硬件原因造'
                        + '成的；内容被百度智能云判定为非法而强制下线的；在百度智能云建议'
                        + '用户修改其服务用法之后，用户未按建议修改其用法而在使用服务过程'
                        + '中造成的；测试和试用服务期间造成的（使用百度智能云提供的免费公'
                        + '测集群，也视为试用服务）；在百度智能云合理控制之外的因素其他造'
                        + '或设备获得对百度短网址服务的访问权限的任何人的行为或疏忽造成'
                        + '的。本产品的免费功能及项目不适用于此协议。';
        const compensationStandard = '服务补偿指因百度智能云设备故障、设计缺陷或操作不当导致客户所购'
                                + '买的百度短网址服务未达到本服务等级协议承诺的业务可用性的，百度'
                                + '智能云将对客户进行赔偿。赔偿规则如下：';
        const principle = '百度智能云对客户未达到业务可用性的授权ID按不可用时间的10倍，'
                        + '赔偿短网址跳转和创建短网址所消耗的点数。'
                        + '赔付点数 = 达到业务可用性的域名在故障前24小时平均每分钟的使用'
                        + '百度短网址跳转和创建短网址所消耗的点数（若不足24小时，则按实际'
                        + '使用时长的平均值计算费用） x 故障时间 x 10';
        const compensationDesc1 = '故障时间=故障解决时间-故障开始时间。按分钟计算故障'
                            + '时间，故障时间小于1分钟的按1分钟计算。例如，故障'
                            + '时间为1分01秒，按2分钟算。';
        const compensationDesc2 = '赔偿只针对已购买百度短网址服务并已产生费用的客户，'
                            + '使用赠送免费额度的客户不包含在内。';
        const others = '百度智能云有权根据变化适时对本服务等级协议部分服务指标作出调整，并及'
                    + '时在百度智能云官网发布公告或发送邮件或书面通知向用户提示修改内容。';
        return (
            <div className="doc-container">
                <div className="sla-content">
                    <h1>百度短网址服务等级协议（SLA）</h1>
                    <h2 className="title">业务功能</h2>
                    <p>{businessFunc}</p>
                    <h2 className="title">业务可用性</h2>
                    <p>{businessAvail}</p>
                    <p>{serviceAvailCalcuFormula}</p>
                    <p>相关说明：</p>
                    <p>{businessAvailDesc1}
                        <br/>{businessAvailDesc2}
                        <br/>{businessAvailDesc3}
                        <br/>4. 以下情况不纳入不可用时间计算：
                        <br/>1) 日常系统维护时间的不可用；
                        <br/>2) 由客户原因，运营商封禁、被非法攻击等第三方原因或不可抗力导致的不可用；
                        <br/>3) 客户针对短网址服务使用的操作不当等造成的短网址服务不可用；
                        <br/>4) 未提前告知的大流量增加（短网址注册：请求量超过 5000次QPS、短网址跳转：
                        请求量超过1万次QPS）引起的不可用；
                        <br/>5) 任何百度智能云设备以外的网络、设备故障或配置调整引起的不可用；
                    </p>
                    <h2 className="title">故障恢复能力</h2>
                    <p>{faultRecovCapa}</p>
                    <h2 className="title">业务资源调配能力</h2>
                    <p>{businessResourceAllocationCapa}</p>
                    <h2 className="title">服务和数据可追溯</h2>
                    <p>客户使用百度短网址服务时，支持查询缩短网址次数、短网址跳转次数等数据。</p>
                    <h2 className="title">服务私密性</h2>
                    <p>百度短网址服务数据的私密性，通过百度短网址的token配置服务来保证。</p>
                    <h2 className="title">服务知情权</h2>
                    <p>1. 客户使用的百度短网址服务所在的数据中心位置可以通过提交工单咨询。
                        <br/>2. 百度智能云数据中心将遵守当地相关的法律法规，客户对此具有知情权，可通过提交工单进行咨询。
                        <br/>3. 未经客户书面许可，百度不会擅自保存、公开、转授权或泄露给任何第三方，也不会用于本协议合作以外用途，除政府监管部门监管审计需要。
                        <br/>4. 除用于对百度智能云百度短网址服务运行状态的统计分析，客户的行为日志不会对外呈现客户个人信息数据。
                    </p>
                    <h2 className="title">服务可审查性</h2>
                    <p>{serviceAuditability}</p>
                    <h2 className="title">服务计量准确性</h2>
                    <p>{serviceMeasureAccuracy}</p>
                    <h2 className="title">服务补偿</h2>
                    <h3>适用范围</h3>
                    <p>此服务等级（SLA）不适用于由以下情况造成的服务的任何性能或可用性问题：
                        <br/>{scopeOfUse}</p>
                    <h3>补偿标准原则</h3>
                    <p>{compensationStandard}</p>
                    <p>{principle}</p>
                    <p>说明：</p>
                    <p>{compensationDesc1}<br/>{compensationDesc2}</p>
                    <h2 className="title">其他</h2>
                    <p>{others}</p>
                </div>
            </div>
            );
    }
}
export default connect(state => ({
    currentPage: state.currentPage
}))(SLA);
